import { loadCustomerConfig } from './customerConfig';

type ModesConfig = CustomerConfig & {
  modes?: string | string[];
};

/**
 * Obtiene los names de modes ya sea si viene string (formato INI legacy) o array (formato JSON nuevo).
 * En formato INI: modes = medespacioMode, oncosurMode
 * En formato JSON: modes: ["medespacioMode", "oncosurMode"]
 */
function getModeNames(modes: string | string[] | undefined): string[] {
  if (!modes) return [];
  if (Array.isArray(modes)) return modes;
  // Formato string legacy INI: "medespacioMode, oncosurMode"
  return modes
    .split(',')
    .map(m => m.trim())
    .filter(Boolean);
}

export async function getCustomer(customerKey: string): Promise<CustomerConfig> {
  const config = await loadCustomerConfig();

  const customer: ModesConfig = config[`customer:${customerKey}`];

  if (!customer) {
    return;
  }

  const modeNames = getModeNames(customer.modes);

  const mergedModes = modeNames.reduce(
    (acc, modeName) => ({
      ...acc,
      ...(config[modeName] || {}),
    }),
    {}
  );

  return {
    ...mergedModes,
    ...customer,
  };
}
